export default __webpack_public_path__ + "static/media/tete61.b5a2e805.png";